import { render } from "./NavbarCSSOnly.vue?vue&type=template&id=2adc274a&scoped=true"
import script from "./NavbarCSSOnly.vue?vue&type=script&lang=js"
export * from "./NavbarCSSOnly.vue?vue&type=script&lang=js"

import "./NavbarCSSOnly.vue?vue&type=style&index=0&id=2adc274a&scoped=true&lang=scss"

import exportComponent from "/builds/dalmadima/umzugbayernwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2adc274a"]])

export default __exports__